import { useState } from 'react'

import '../styles/aisignals.css'
import { RiArrowDropDownLine } from "react-icons/ri";

const AiSignals = () => {
    const [aActive, setAActive] = useState(false);
    const [bActive, setBActive] = useState(false);
    const [cActive, setCActive] = useState(false);
  return (
    <>
      <div className="aisignals">
        <div className="tabs">
          <ul>
            <li>
              <div className="aisig">
                <h3>AI-Powered <span className="ent">ENTRY</span> & <span className="xit">EXIT</span> Signals</h3>
                <div className={'how ' + (aActive ? ' active' : ' ')} onClick={(e) => setAActive(!aActive)}>
                  <div className="qst">
                    <h5>How does it work?</h5>
                    <RiArrowDropDownLine />
                  </div>
                  <p>Our AI runs continuously in the background, scanning over 200 technical indicators across multiple timeframes at the same time. 
                    It looks at price momentum, volume patterns, moving averages, market structure, and dozens of other signals to build a complete 
                    picture of what a market is doing right now. When the AI detects a setup that meets its high-confidence threshold, it generates a signal instantly. 
                    That signal includes a precise entry price, a stop loss to protect your downside, and a take profit target to lock in your gains. Every signal also comes 
                    with a confidence score from 0 to 100, so you can see exactly how strong the setup is before you act. The whole process happens in under a second so you never miss the move.</p>
                </div>
                <div className="ind">
                  <p className="lft">INDICATORS ANALYZED</p>
                  <p className="ryt">200+</p>
                  <div className="bars">
                    <div className="bar"></div>
                  </div>
                  <div className="parameter grn">
                    <div className="lft">
                      <p>ACCURACY</p>
                      <h6>94.7%</h6>
                    </div>
                    <div className="ryt">
                      <p>WIN RATE</p>
                      <ul className="brs">
                        <li className='cndl'></li>
                        <li className='cndl'></li>
                        <li className='cndl'></li>
                        <li className='cndl'></li>
                        <li className='cndl'></li>
                        <li className='cndl'></li>
                        <li className='cndl'></li>
                        <li className='cndl lyt'></li>
                      </ul>
                    </div>
                  </div>
                  <div className="parameter ylw">
                    <div className="lft">
                      <p>COMMUNITY GENERATED</p>
                      <h6>$74M+</h6>
                    </div>
                    <div className="ryt">
                      <p>Since</p>
                      <p>2023</p>
                    </div>
                  </div>
                  <div className="score">
                    <div className="lft">
                      <h6>CONFIDENCE</h6>
                      <p>Scoring</p>
                    </div>
                    <div className="ryt">
                      <h6>RISK</h6>
                      <p>Assessment</p>
                    </div>
                  </div>
                </div>
              </div>
              <p className="btm">remove emotion frrom trading</p>
            </li>
            <li>
              <div className="aisig">
                <h3>Lightning-Fast Alerts</h3>
                <div className="parameter ylw">
                  <div className="lft">
                    <p>AVG DELIVERY</p>
                    <h6>0.3s</h6>
                  </div>
                  <div className="ryt">
                    <p>LATENCY</p>
                    <ul className="brs">
                      <li className="cndl" style={{"--hgt": "10px"}}></li>
                      <li className="cndl" style={{"--hgt": "12px"}}></li>
                      <li className="cndl" style={{"--hgt": "14px"}}></li>
                      <li className="cndl" style={{"--hgt": "18px"}}></li>
                      <li className="cndl" style={{"--hgt": "16px"}}></li>
                      <li className="cndl" style={{"--hgt": "18px"}}></li>
                      <li className="cndl" style={{"--hgt": "18px"}}></li>
                    </ul>
                  </div>
                </div>
                <div className={'how ' + (bActive ? ' active' : ' ')} onClick={(e) => setBActive(!bActive)}>
                  <div className="qst">
                    <h5>How does it work?</h5>
                    <RiArrowDropDownLine />
                  </div>
                  <p>When a signal fires, it hits our real-time delivery pipeline in milliseconds. 
                    We maintain persistent WebSocket connections to Discord servers and direct push channels to your phone, so there is no polling delay. 
                    The moment our AI validates a signal, your entry price, stop loss, 
                    and take profit are pre-calculated and packaged into a notification that reaches you in under 0.3 seconds on average. You do not need to be watching charts — the system does the watching for you.
                  </p>
                </div>
                <div className="lines">
                  <p>DELIVERY CHANNELS</p>
                  <ul>
                    <li>
                      <div className="txts">
                        <p>Discord</p>
                        <p className="lv">Live</p>
                      </div>
                      <div className="bars">
                        <div className="bar" style={{"--hgt": "100%"}}></div>
                      </div>
                    </li>
                    <li>
                      <div className="txts">
                        <p>Mobile push</p>
                        <p className="lv">Live</p>
                      </div>
                      <div className="bars">
                        <div className="bar" style={{"--hgt": "100%"}}></div>
                      </div>
                    </li>
                    <li>
                      <div className="txts">
                        <p>Email</p>
                        <p className="lv">99.8%</p>
                      </div>
                      <div className="bars">
                        <div className="bar" style={{"--hgt": "95%"}}></div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="more grn">
                  <p>INCLUDED IN EVERY ALERT</p>
                  <h6>Entry.stop Loss.Take perofit</h6>
                </div>
              </div>
              <p className="btm">Never miss an opportunity</p>
            </li>
            <li>
              <div className="aisig">
                <h3>Smart Money Detection</h3>
                <div className="parameter purps">
                  <div className="lft">
                    <p>INSTITUTIONAL FLOW</p>
                    <h6>$50M+</h6>
                  </div>
                  <div className="ryt">
                    <p>DAILY TRACKED</p>
                    <p>LIVE</p>
                  </div>
                </div>
                <div className={'how ' + (cActive ? ' active' : ' ')} onClick={(e) => setCActive(!cActive)}>
                  <div className="qst">
                    <h5>How does it work?</h5>
                    <RiArrowDropDownLine />
                  </div>
                  <p>Large institutions cannot trade without leaving a footprint. We monitor dark pool print feeds, unusual options activity, 
                    and large block trades across all major exchanges in real time. When we detect a cluster of institutional buying or selling that breaks from normal patterns, 
                    we flag it as a directional signal. This gives you the same market intelligence that was previously only available to hedge funds and professional trading desks.
                    </p>
                </div>
                <div className="lines">
                  <p>SIGNAL SOURCES</p>
                  <ul>
                    <li>
                      <div className="txts">
                        <p>Dark pool prints</p>
                        <p>38%</p>
                      </div>
                      <div className="bars">
                        <div className="bar purps" style={{"--hgt": "38%"}}></div>
                      </div>
                    </li>
                    <li>
                      <div className="txts">
                        <p>Options flow</p>
                        <p>34%</p>
                      </div>
                      <div className="bars">
                        <div className="bar" style={{"--hgt": "34%"}}></div>
                      </div>
                    </li>
                    <li>
                      <div className="txts">
                        <p>Block Trades</p>
                        <p>28%</p>
                      </div>
                      <div className="bars">
                        <div className="bar grn" style={{"--hgt": "28%"}}></div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="more ylw">
                  <p>CATCHES BREAKOUTS</p>
                  <h6>Avg 4.2min before crowd</h6>
                </div>
                <p className="btm">Trade like the pros</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default AiSignals